<template>
    <div class="container" v-if="pages !== null">
        <b-table :data="pages" striped hoverable>
            <template slot-scope="props">
                <b-table-column label="Controls">
                    <i class="fa fa-edit fa-2x" @click="$router.push({name: 'AdminPageEdit', params: { id: props.row.id }})"></i>

                    <i class="fa fa-eye fa-2x" @click="$router.push({name: 'PageView', params: {
                            id: props.row.id, nice_name: encodeURIComponent(props.row.title.replace(new RegExp(' ', 'g'), '_').toLowerCase()) }})"></i>
                </b-table-column>
                <b-table-column label="ID" numeric>
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column label="Title">
                    {{props.row.title}}
                </b-table-column>
                <b-table-column label="Last Updated">
                    {{ props.row.updatedAt }}
                </b-table-column>
            </template>
        </b-table>
        <button class="button" @click="$router.push('/admin/page/new')">Create Page</button>
    </div>
</template>

<script>
import { HTTP } from '../../http';
import BTable from 'buefy/src/components/table/Table';
import BTableColumn from 'buefy/src/components/table/TableColumn';

export default {
  components: {
    BTableColumn,
    BTable,
  },
  name: 'admin-pages',

  created() {
    this.loadPages();
  },

  data() {
    return {
      pages: null,
      loadingPages: false,
    };
  },

  methods: {
    loadPages() {
      HTTP.get('/admin/pages/')
        .then((resp) => {
          this.pages = resp.data;
        })
        .catch((err) => context.commit('error/set', err.response.data, { root: true }));
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminPages.vue